<template>
  <div class="division-label body-box">
    <div class="division-label-left">
      <Tree
        @changeSwitch="changeSwitch"
        :switchVal="searchParams.isDown"
        :levelNum="3"
        @nodeClick="nodeClick"
      ></Tree>
    </div>
    <div class="division-label-righ">
      <TabelSearch
        :searchConfig="searchConfig"
        :searchParams="searchParams"
        @resetCallBack="resetCallBack"
        @search="setSearchParams"
      ></TabelSearch>
      <Table
        :width="'100%'"
        :tableLoading="tableLoading"
        :tabelButtons="tabelButtons"
        :templateData="tableTemplateData"
        :tableConfig="tableConfig"
        :pagination="pagination"
      >
      </Table>
    </div>
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="title"
      :visible.sync="dialogVisible"
      width="85%"
      :before-close="handleClose"
    >
      <el-form :model="ruleForm" :inline="true" class="formBoxStyle" :rules="rules" ref="ruleForm" label-width="100px">
        <el-row class="row_1_style">
          <el-col :span="4.5">
            <el-form-item label="网关名称" prop="name">
              <el-input v-model="ruleForm.name"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4.5">
            <el-form-item label="网关类型" prop="name">
              <el-select v-model="ruleForm.type" placeholder="请选择类型">
                <el-option 
                  v-for="(item, k) in typeOptions"
                  :key="k"
                  :label="item.itemName" 
                  :value="item.itemValue"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="秘钥appKey" prop="name">
              <el-input v-model="ruleForm.appKey"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="秘钥appSecret" label-width="120px"  prop="name">
              <el-input v-model="ruleForm.appSecret"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4.5">
            <el-form-item label="host" prop="host" label-width="80px" >
              <el-input v-model="ruleForm.host"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      
        <el-form-item label="路径地址配置" label-width="120px">
          <div class="peizhiBox">
            <el-button type="primary" 
              icon="el-icon-plus" 
              circle style="margin-bottom: 8px;"
              @click="addBigRow(bigArr)"
            ></el-button>
            <el-row class="rowStyleB" v-for="(item, k) in bigArr" :key="k">
              <el-col :span="23">
                <el-card class="box-card">
                  <el-col :span="24" class="marginbottom10 basePeizhi">
                    <el-form-item class="style1" label="类型地址" label-width="80px">
                      <el-select v-model="item.requestType" placeholder="请求类型">
                          <el-option 
                          v-for="(methItem, methK) in methOption"
                          :key="methK"
                          :label="methItem.key" 
                          :value="methItem.value"
                          ></el-option>
                        </el-select>
                        <el-input placeholder="请求地址" v-model="item.url"></el-input>
                      </el-form-item>
                      <el-form-item label="请求CodeKey" label-width="100px">
                        <el-input v-model="item.appSecret.codeKey" placeholder="请求CodeKey"></el-input>
                      </el-form-item>
                      <el-form-item label="判断值" label-width="60px">
                        <el-input v-model="item.appSecret.codeValue" placeholder="判断值"></el-input>
                      </el-form-item>
                      <el-form-item label="是否分页" label-width="70px">
                        <el-switch v-model="item.appSecret.pageType" active-color="#13ce66" inactive-color="#ff4949"> </el-switch>
                      </el-form-item>
                      <el-form-item label="获取数据的Key" label-width="110px">
                        <el-input v-model="item.appSecret.parameterKey" placeholder="获取数据的Key"></el-input>
                      </el-form-item>
                      <el-form-item label="数据表名称" label-width="90px">
                        <el-select v-model="item.tableName" filterable  placeholder="数据表名称">
                          <el-option 
                            v-for="(tab, tabk) in tableNameOptions"
                            :key="tabk"
                            :label="tab" 
                            :value="tab"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                  </el-col>

                  <el-col :span="12" class="rowStyleB">
                    <el-form-item label="数据对象(key:value)" label-width="140px">
                      <el-button type="primary" icon="el-icon-plus" 
                        style="margin-bottom: 8px;" 
                        @click="addKeyValue(item.mapArr,k)" circle></el-button>
                      <div v-for="(itemk, i) in item.mapArr" :key="i" class="keyvaluerow">
                        <el-input placeholder="key" v-model="itemk.key"></el-input> :
                        <el-input placeholder="value" v-model="itemk.value"></el-input>
                        <el-button type="danger" v-if="item.mapArr.length > 1"
                          icon="el-icon-delete" 
                          style="margin-left: 8px;"
                          size="small"
                          @click="delKeyValue(item.mapArr,i)"
                          circle>
                        </el-button>
                      </div>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12" class="rowStyleB">
                    <el-form-item label="请求参数:对应解析的数据参数" label-width="200px">
                      <el-button type="primary" icon="el-icon-plus" 
                        style="margin-bottom: 8px;" 
                        @click="addKeyValue(item.requestParamArr,k)" circle></el-button>
                      <div v-for="(itemv, iv) in item.requestParamArr" :key="iv" class="keyvaluerow">
                        <el-input placeholder="key" v-model="itemv.key"></el-input> :
                        <el-input placeholder="value" v-model="itemv.value"></el-input>
                        <el-button type="danger"
                          icon="el-icon-delete" 
                          style="margin-left: 8px;"
                          size="small"
                          @click="delKeyValue(item.requestParamArr,iv)"
                          circle>
                        </el-button>
                      </div>
                    </el-form-item>
                  </el-col>
                </el-card>
              </el-col>
              <el-col :span="1" class="delBoxbigRow">
                <el-button type="danger" v-if="bigArr.length > 1"
                          icon="el-icon-delete" 
                          @click="delBigRow(bigArr,k)"
                          circle>
                        </el-button>
              </el-col>
            </el-row>
          </div>
          
        </el-form-item>
        <el-row>
          <el-col :span="24" style="text-align: right;">
            <el-form-item>
              <el-button type="primary" @click="submitForm('ruleForm')">确定</el-button>
              <el-button @click="handleClose">取消</el-button>
            </el-form-item>
          </el-col>
        </el-row>
       
      </el-form>
    </el-dialog>
    <!-- httpApi配置 -->
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="title1"
      :visible.sync="httpapiDialog"
      width="85%"
      :before-close="handleCloseApi"
    >
      <el-form class="formBoxStyle" :inline="true">
        <el-form-item label="httpApi配置" label-width="120px">
          <div class="peizhiBox">
            <el-button type="primary" 
              icon="el-icon-plus" 
              circle style="margin-bottom: 8px;"
              @click="addBigRow(configArr)"
            ></el-button>
            <el-row class="rowStyleB" v-for="(item, k) in configArr" :key="k">
              <el-col :span="23">
                <el-card class="box-card">
                  <el-col :span="24" class="marginbottom10 basePeizhi">
                    <el-form-item class="style1" label="类型地址" label-width="100px">
                      <el-select v-model="item.requestType" placeholder="请求类型">
                          <el-option 
                          v-for="(methItem, methK) in methOption"
                          :key="methK"
                          :label="methItem.key" 
                          :value="methItem.value"
                          ></el-option>
                        </el-select>
                        <el-input placeholder="请求地址" v-model="item.url"></el-input>
                      </el-form-item>
                      <el-form-item label="请求CodeKey" label-width="100px">
                        <el-input v-model="item.appSecret.codeKey" placeholder="请求CodeKey"></el-input>
                      </el-form-item>
                      <el-form-item label="判断值" label-width="60px">
                        <el-input v-model="item.appSecret.codeValue" placeholder="判断值"></el-input>
                      </el-form-item>
                      <el-form-item label="是否分页" label-width="70px">
                        <el-switch v-model="item.appSecret.pageType" active-color="#13ce66" inactive-color="#ff4949"> </el-switch>
                      </el-form-item>
                      <el-form-item label="获取数据的Key" label-width="110px">
                        <el-input v-model="item.appSecret.parameterKey" placeholder="获取数据的Key"></el-input>
                      </el-form-item>
                      <el-form-item label="标签">
                        <el-select v-model="item.urlType" filterable  placeholder="请选择标签">
                          <el-option 
                            v-for="(tab, tabk) in urlTypeOptions"
                            :key="tabk"
                            :label="tab.itemName" 
                            :value="tab.itemValue"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                  </el-col>

                  <el-col :span="12" class="rowStyleB">
                    <el-form-item label="数据对象(key:value)" label-width="140px">
                      <el-button type="primary" icon="el-icon-plus" 
                        style="margin-bottom: 8px;" 
                        @click="addKeyValue(item.mapArr,k)" circle></el-button>
                      <div v-for="(itemk, i) in item.mapArr" :key="i" class="keyvaluerow">
                        <el-input placeholder="key" v-model="itemk.key"></el-input> :
                        <el-input placeholder="value" v-model="itemk.value"></el-input>
                        <el-button type="danger"
                          icon="el-icon-delete" 
                          style="margin-left: 8px;"
                          size="small"
                          @click="delKeyValue(item.mapArr,i)"
                          circle>
                        </el-button>
                      </div>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12" class="rowStyleB">
                    <el-form-item label="请求参数:对应解析的数据参数" label-width="200px">
                      <el-button type="primary" icon="el-icon-plus" 
                        style="margin-bottom: 8px;" 
                        @click="addKeyValue(item.requestParamArr,k)" circle></el-button>
                      <div v-for="(itemv, iv) in item.requestParamArr" :key="iv" class="keyvaluerow">
                        <el-input placeholder="key" v-model="itemv.key"></el-input> :
                        <el-input placeholder="value" v-model="itemv.value"></el-input>
                        <el-button type="danger"
                          icon="el-icon-delete" 
                          style="margin-left: 8px;"
                          size="small"
                          @click="delKeyValue(item.requestParamArr,iv)"
                          circle>
                        </el-button>
                      </div>
                    </el-form-item>
                  </el-col>
                </el-card>
              </el-col>
              <el-col :span="1" class="delBoxbigRow">
                <el-button type="danger" v-if="configArr.length > 1"
                          icon="el-icon-delete" 
                          @click="delBigRow(configArr,k)"
                          circle>
                        </el-button>
              </el-col>
            </el-row>
          </div>
        </el-form-item>
        <el-row>
          <el-col :span="24" style="text-align: right;">
            <el-form-item>
              <el-button type="primary" @click="submitHttpApi()">确定</el-button>
              <el-button @click="handleCloseApi">取消</el-button>
            </el-form-item>
          </el-col>
        </el-row>
       
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import Tree from "../../../../components/Tree/nodeTree";
import Table from "../../../../components/table/table";
import TabelSearch from "../../../../components/tabel-search/tabel-search";
import { vidiconApi } from "../../../../api-path/vidicon-api";
import publicApi from "../../../../api-path/public-api";
export default {
  name: "division-label",
  //editForm
  components: {
    Table,
    TabelSearch,
    Tree,
  },
  data() {
    return {
      ruleForm: {
        areaId: "",
        areaCode: '',
        id: "",
        name: "", // 名称
        // url: "", //网关地址
        type: "", //  类型(字典)
        secretDb: {},
        appKey: '',
        appSecret: '',
        host: '',
        url: [] // 网关地址
      },
      wanObj: {
        appSecret: {
          codeKey: '',
          codeValue: '',
          pageType: true,
          parameterKey: ''
        },
        mapDB: {}, // key:value 形式，自己可以添加多组 数据对象->映射表
        mapArr: [
          { key: '', value: '' }
        ],
        requestParam: {}, // 请求参数->对应解析的数据参数
        requestParamArr: [], // 请求参数可以没有
        requestType: '',
        tableName: '',
        url: ''
      },
      bigArr: [], // 内容最外层数组
      tagIds: [],
      methOption: [
        {key: 'POST', value: 'POST' },
        {key: 'GET', value: 'GET' },
        {key: 'DELETE', value: 'DELETE' },
        {key: 'PUT', value: 'PUT' },
      ],
      tableNameOptions: [],
      rules: {
        name: [{ required: true, message: "请输入网关名称", trigger: "blur" }],
        url: [{ required: true, message: "请输入网关地址", trigger: "blur" }],
        type: [{ required: true, message: "请选择类型", trigger: "blur" }],
        appKey: [{ required: true, message: "请输入秘钥appKey", trigger: "blur" }],
        appSecret: [{ required: true, message: "请输入秘钥appSecret", trigger: "blur" }],
        host: [{ required: true, message: "请输入host", trigger: "blur" }],
      },
      title: "新增网关",
      title1: "httpApi网关配置",
      title2: '复制httpApi配置设置',
      dialogVisible: false,
      searchParams: {
        areaCode: "", // 区域(国际)编号
        isDown: false, //是否想下查询
        type: '', // 类型
        page: 1,
        size: 15,
      },
      searchConfig: {
        dataName: "searchParams",
        items: [
         {
            key: "type",
            valueType: "select",
            placeholder: "选择类型",
            option: {
              label: "itemName",
              value: "itemValue",
            },
            path: publicApi.queryByCodeValue + "/PERSON_USER_TYPE",
          }
        ],
      },
      //表格
      tableLoading: false,
      tableTemplateData: [],
      tabelButtons: [
        {
          type: "add",
          fn: () => {
            Object.assign(this.ruleForm, this.$options.data().ruleForm)
            this.ruleForm.areaId = this.areaId
            this.ruleForm.areaCode = this.areaCode
            console.log('this.ruleForm', this.ruleForm)
            let obj = JSON.parse(JSON.stringify(this.wanObj))
            this.bigArr = [obj]
            this.dialogVisible = true;

          },
        },
      ],
      tableConfig: {
        checkbox: true,
        index: true,
        checkboxFn: (data) => {
          this.tagIds = [];
          data.forEach((item) => {
            this.tagIds.push(item.id);
          });
        },
        rows: [
          {
            label: "名称",
            prop: "name",
          },
          // {
          //   label: "网关地址",
          //   prop: "url",
          // },
          {
            label: "类型",
            prop: "type",
          },
          {
            label: "最近同步时间",
            prop: "createGmt",
          },
        ],
        rowButtons: {
          width: "460px",
          items: [
            {
              label: "编辑",
              fn: (data) => {
                this.title = "编辑网关";
                this.ruleForm = JSON.parse(JSON.stringify(data))
                if (Object.keys(data.secretDb).length > 0) {
                  this.$set(this.ruleForm, 'appKey', data.secretDb.appKey)
                  this.$set(this.ruleForm, 'appSecret', data.secretDb.appSecret)
                  this.$set(this.ruleForm, 'host', data.secretDb.host)
                } else {
                  this.$set(this.ruleForm, 'appKey', '')
                  this.$set(this.ruleForm, 'appSecret', '')
                  this.$set(this.ruleForm, 'host', '')
                }
                let arr = data.url
                arr.forEach(val => {
                  let mapArr = []
                  for(let i in val.mapDB) {
                    let obj = {
                      key: i,
                      value: val.mapDB[i]
                    }
                    mapArr.push(obj)
                  }
                  val['mapArr'] = mapArr

                  let requestParamArr = []
                  if (Object.keys(val.requestParam).length > 0) {
                      for(let i in val.requestParam) {
                      let obj1 = {
                        key: i,
                        value: val.requestParam[i]
                      }
                      requestParamArr.push(obj1)
                    }
                    val['requestParamArr'] = requestParamArr
                  }
                })

                this.bigArr = JSON.parse(JSON.stringify(arr))
                this.dialogVisible = true;
              },
            },
            {
              label: "删除",
              type: "danger",
              fn: (data) => {
                this.$confirm("此操作将删除该网关, 是否继续?", "提示", {
                  confirmButtonText: "确定",
                  cancelButtonText: "取消",
                  type: "warning",
                })
                  .then(() => {
                    this.$http
                      .delete(vidiconApi.gatewayCameraTagDel, { params: { id: data.id } })
                      .then((res) => {
                        if (res.status == 200) {
                          this.$message.success("删除成功");
                          this.startSearch();
                        }
                      });
                  })
                  .catch(() => {});
              },
            },
            {
              label: "同步",
              fn: (data) => {
              this.$http
                    .get(vidiconApi.gatewayCameraSync, { params: { id: data.id } })
                    .then((res) => {
                      if (res.status == 200) {
                        this.$message.success("同步成功");
                        this.startSearch();
                      }
                    });
              },
            },
            {
              label: "httpApi配置",
              fn: (data) => {
                this.httpApiForm.id = data.id
                let obj = JSON.parse(JSON.stringify(this.wanObj))
                obj.mapArr = []
                if (data.urlApi) {
                  let arr = data.urlApi
                  arr.forEach(val => {
                    let mapArr = []
                    for(let i in val.mapDB) {
                      let obj = {
                        key: i,
                        value: val.mapDB[i]
                      }
                      mapArr.push(obj)
                    }
                    val['mapArr'] = mapArr

                    let requestParamArr = []
                    if (Object.keys(val.requestParam).length > 0) {
                        for(let i in val.requestParam) {
                        let obj1 = {
                          key: i,
                          value: val.requestParam[i]
                        }
                        requestParamArr.push(obj1)
                      }
                      val['requestParamArr'] = requestParamArr
                    }
                  })
                  this.configArr = JSON.parse(JSON.stringify(arr))
                } else {
                  this.configArr = [obj]
                }
                this.httpapiDialog = true;
              },
            },
            {
              label: "复制",
              fn: (data) => {
                this.copyForm.copyId = data.id
                this.$message.success('httpApi配置已复制')
              },
            },
            {
              label: "粘贴",
              fn: (data) => {
                if (!this.copyForm.copyId) {
                  this.$message.error('请先选择需要复制的对象')
                  return
                }
                this.$confirm("确定粘贴已复制的httpApi配置?", "提示", {
                  confirmButtonText: "确定",
                  cancelButtonText: "取消",
                  type: "warning",
                })
                  .then(() => {
                    this.copyForm.id = data.id
                    console.log('copyform', this.copyForm)
                    if (this.copyForm.id === this.copyForm.copyId) {
                      this.$message.error('复制粘贴的对象不能相同')
                      return
                    }
                    this.$http
                      .get(vidiconApi.gatewayCameraCopyUrlAPI, { params: this.copyForm })
                      .then((res) => {
                        if (res.status == 200) {
                          this.$message.success("粘贴成功");
                          this.startSearch();
                        }
                      });
                  })
                  .catch(() => {});
              },
            },
          ],
        },
      },
      pagination: {
        show: true,
        total: 0,
        page: 1,
        size: 15,
        sizeChange: this.sizeChange,
        pageChange: this.pageChange,
      }, // 分页
      //标签下面的
      areaId: '',
      areaCode: '',
      typeOptions: [],
      httpapiDialog: false,
      configArr: [],
      httpApiForm: {
        id: '',
        url: []
      },
      urlTypeOptions: [], // 类型:标签: THIRD_HTTP_API
      copyForm: {
        copyId: '',
        id: ''
      },
      copyRules: {
        copyId: [{ required: true, message: "请复制目标", trigger: "change" }],
        id: [{ required: true, message: "请选择粘贴目标", trigger: "change" }],
      },
      formConfig: {
        disabled: false,
        items: [
          [
            {
              valueType: "select",
              label: "复制对象",
              key: "copyId",
              prop: "copyId",
              labelWidth: "120px",
              itemWidth: "100%",
              maxlength: "50",
              placeholder: "请选择复制对象",
              options: {
                label: 'itemName', value: 'itemValue'
              },
              data: []
            },
          ],
          [
            {
              valueType: "select",
              label: "粘贴对象",
              key: "id",
              prop: "id",
              labelWidth: "120px",
              itemWidth: "100%",
              maxlength: "50",
              placeholder: "请选择粘贴对象",
              options: {
                label: 'itemName', value: 'itemValue'
              },
              data: []
            },
          ],

        ],
      },
      buttonConfig: {
        buttons: [
          {
            type: "save", // 保存
            loading: false,
            fn: (data) => {
              console.log('data', data)
              let obj = JSON.parse(JSON.stringify(data))
              obj.secretDb = {
                appKey: data.appKey,
                appSecret: data.appSecret
              }
              delete obj.appKey
              delete obj.appSecret
              this.$http.post(vidiconApi.gatewayCameraSave, obj).then((res) => {
                if (res.status === 200) {
                  this.$message.success(this.title + "成功");
                  this.dialogVisible = false;
                  this.startSearch();
                }
              });
            },
          },
          {
            type: "back", // 返回
            fn: () => {
              this.handleClose();
            },
          },
        ],
      },
    };
  },
  created() {
    this.getTypeCode()
    this.getTabName()
    this.getUrlType()
  },
  methods: {
    changeSwitch(e) {
      this.searchParams.isDown = e;
      this.isDown = e;
      this.startSearch();
    },
    getTypeCode() {
      this.$http.get(publicApi.queryByCodeValue + '/GATEWAY_CAMER_TYPE').then((res) => {
          if (res.status === 200) {
            this.typeOptions = res.result
          }
        });
    },
    nodeClick(node) {
      this.searchParams.areaCode = node.areaId;
      this.ruleForm.areaId = node.id;
      this.ruleForm.areaCode = node.areaId;
      this.areaCode = node.areaId
      this.areaId = node.id
      this.searchParams.page = this.pagination.page = 1;
      this.startSearch();
    },
    startSearch() {
      this.$http
        .get(vidiconApi.gatewayCameraListPage, {
          params: this.searchParams,
        })
        .then((res) => {
          if (res.status == 200) {
            this.tableTemplateData = res.result.pageList;
            this.pagination.total = res.result.total;
          }
        });
    },
    setSearchParams(value) {
      if (value) {
        this.pagination.page = value.page;
      }
      this.startSearch();
    },
    resetCallBack() {
      this.searchParams.areaCode = this.areaCode;
      this.searchParams.isDown = this.isDown;
      this.searchParams.page = this.pagination.page = 1;
      this.startSearch();
    },
    handleClose() {
      this.dialogVisible = false;
    },
    handleCloseApi() {
      this.httpapiDialog = false;
    },
    // 每页显示条数
    sizeChange(size) {
      this.pagination.size = size;
      this.searchParams.size = size;
      this.startSearch();
    },
    // 当前页
    pageChange(page) {
      this.pagination.page = page;
      this.searchParams.page = page;
      this.startSearch();
    },
    // 新增key:value
    addKeyValue(data) {
      data.push({key: '', value: ''})
    },
    // 删除key:value
    delKeyValue(data,index) {
      console.log('data1', data)
      data.splice(index, 1)
      console.log('data', data)
    },
    // 添加大行数据
    addBigRow(data) {
      let obj = JSON.parse(JSON.stringify(this.wanObj))
      data.push(obj)
    },
    // 删除大行数据
    delBigRow(data,index) {
      data.splice(index, 1)
    },
    getTabName() {
      this.$http
        .get(vidiconApi.gatewayCameraTableName)
        .then((res) => {
          if (res.status == 200) {
            this.tableNameOptions = res.result
          }
        });
    },
    getUrlType() {
      this.$http
        .get(publicApi.queryByCodeValue+ "/THIRD_HTTP_API")
        .then((res) => {
          if (res.status == 200) {
            this.urlTypeOptions = res.result
          }
        });
    },
    submitForm(form) {
        this.$refs[form].validate((valid) => {
          if (valid) {
            let obj = JSON.parse(JSON.stringify(this.ruleForm))
            obj.secretDb = {
              appKey: obj.appKey,
              appSecret: obj.appSecret,
              host: obj.host
            }
            delete obj.appKey
            delete obj.appSecret
            delete obj.host
            let arr = JSON.parse(JSON.stringify(this.bigArr))
            if (arr.length > 0) {
              let arrOutCheck = arr.every(resItem => {
                let check = resItem.appSecret.codeKey !== '' && resItem.appSecret.codeValue !== '' &&
                resItem.appSecret.parameterKey !== '' && resItem.requestType !== '' && resItem.url !== ''
                let arrCheck = resItem.mapArr.every(mapVal => {
                  return mapVal.key !== '' && mapVal.value !== ''
                })
                let requestParamArrCheck = resItem.requestParamArr.every(mapVal => {
                  return mapVal.key !== '' && mapVal.value !== ''
                })
                
                return check && arrCheck && requestParamArrCheck
              })

              console.log('arrOutCheck', arrOutCheck)

              if (!arrOutCheck) {
                this.$message.error('请输入完整路径地址配置')
                return
              }

              arr.forEach(val => {
                if (val.mapArr.length > 0) {
                  let obj = {}
                  val.mapArr.forEach(item => {
                    obj[item.key] = item.value
                  })
                  val.mapDB = obj
                }
                delete val.mapArr

                if (val.requestParamArr.length > 0) {
                  let obj1 = {}
                  val.requestParamArr.forEach(item => {
                    obj1[item.key] = item.value
                  })
                  val.requestParam = obj1
                }  else {
                    val.requestParam = {}
                  } 
                delete val.requestParamArr
              })
              console.log('arr------', arr)
            }
            obj.url = arr
            console.log('ruleForm', obj)
            this.$http.post(vidiconApi.gatewayCameraSave, obj).then((res) => {
                if (res.status === 200) {
                  this.$message.success(this.title + "成功");
                  this.dialogVisible = false;
                  this.startSearch();
                }
              });
          } else {
              this.$message.error('请输入完整')
          }
        });
    },
    submitHttpApi() {
      // console.log('this.configArr', this.configArr)
      let arr = JSON.parse(JSON.stringify(this.configArr))
      if (arr.length > 0) {
        let arrOutCheck = arr.every(resItem => {
          let check = resItem.appSecret.codeKey !== '' && resItem.appSecret.codeValue !== '' &&
          resItem.appSecret.parameterKey !== '' && resItem.requestType !== '' && resItem.url !== ''
          let arrCheck = resItem.mapArr.every(mapVal => {
            return mapVal.key !== '' && mapVal.value !== ''
          })
          let requestParamArrCheck = resItem.requestParamArr.every(mapVal => {
            return mapVal.key !== '' && mapVal.value !== ''
          })
          
          return check && arrCheck && requestParamArrCheck
        })

        console.log('arrOutCheck', arrOutCheck)

        if (!arrOutCheck) {
          this.$message.error('请输入完整httpApi配置')
          return
        }
        // console.log('arr', arr)
        arr.forEach(val => {
          if (val.mapArr.length > 0) {
            let obj = {}
            val.mapArr.forEach(item => {
              obj[item.key] = item.value
            })
            val.mapDB = obj
          } else {
            val.mapDB = {}
          }
          delete val.mapArr

          if (val.requestParamArr.length > 0) {
            let obj1 = {}
            val.requestParamArr.forEach(item => {
              obj1[item.key] = item.value
            })
            val.requestParam = obj1
          } else {
            val.requestParam = {}
          }
          delete val.requestParamArr
        })
        console.log('arr------', arr)
      }
      // return
      this.httpApiForm.url = arr
      console.log('ruleForm', this.httpApiForm)
      this.$http.post(vidiconApi.gatewayCameraUrlApi, this.httpApiForm).then((res) => {
          if (res.status === 200) {
            this.$message.success(this.title1 + "成功");
            this.httpapiDialog = false;
            this.startSearch();
          }
        });
    }
  },
};
</script>

<style scoped lang="less">
.division-label {
  margin-left: 10px;
  box-sizing: border-box;
  height: 100%;
  padding: 10px;
  border-radius: 10px;
  background: #fff;
  display: flex;
  .division-label-left {
    margin-right: 10px;
    border-right: 1px solid #c1c1c1;
  }

  .division-label-righ {
	flex: 1;
	display: flex;
	flex-direction: column;
  }
}

.box-card {
}
.keyvaluerow {
  margin-bottom: 4px;
  display: flex;
}
.rowStyleB {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
.delBoxbigRow {
  display: flex;
  align-items: center;
  justify-content: center;
}

.rowT1 {
  margin: 8px 0;
}

.rowBottom {
  margin-bottom: 8px;
}

.peizhiBox {
  max-height: 440px;
  overflow: auto;
}

.formBoxStyle {
  .row_1_style {
    ::v-deep {
      div.el-input {
        width: 180px!important;
      }
    }
  }
  
.marginbottom10 {
  margin-bottom: 10px;
}

  .basePeizhi {
    ::v-deep {
      div.el-input, div.el-select {
        width: 140px!important;
      }
    }
  }


  .style1 {
    ::v-deep {
      div.el-input {
        width: 198px!important;
      }
       div.el-select, div.el-input--suffix {
        width: 100px!important;
      }
      
    }
  }




}
</style>
<style>
  
</style>
